import {
  Box,
  Card,
  CardContent,
  IconButton,
  Modal,
  CardActions,
  Typography,
  styled,
} from "@mui/material";
import { HighlightOff } from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";
import LogoutModalButton from "../auth/logoutModal/LogoutModalButton";
import { modalStyle } from "../../_utils/modalStyle";

const CardImage = styled("img")({
  position: "relative",
  left: "24%",
  width: "45%",
  marginTop: 1,
});

const FinishLaterTestModal: React.FC<{
  open: boolean;
  width?: string;
  close: () => void;
  finishLater: () => void;
  skill?: boolean;
}> = ({ open, close, finishLater, width = "510px", skill }) => {
  const { t } = useTranslation("common");

  const handle = () => {
    finishLater();
  };

  return (
    <Modal open={open} onClose={close}>
      <Card
        sx={{
          ...modalStyle,
          width: {
            xs: "95%",
            sm: !width ? "auto" : width,
            md: !width ? "auto" : width,
          },
        }}
      >
        <CardContent sx={{ pt: 0 }}>
          <Box sx={{ width: "100%", display: "flex" }}>
            <IconButton
              aria-label="close"
              onClick={close}
              sx={{ ml: "auto", mt: 1, mr: -1, mb: 1 }}
            >
              <HighlightOff />
            </IconButton>
          </Box>
          <CardImage
            alt="Logout icon"
            src="/static/illustrations/Logout-illu.svg"
          />
          <Typography
            variant="h5"
            sx={{ textAlign: "center", mt: 3, fontWeight: 600 }}
          >
            {skill
              ? "Voulez-vous vraiment finir de compléter vos compétences plus tard ?"
              : t("tests.modal.finish_later_text")}
          </Typography>
          <CardActions
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              mt: 3,
            }}
          >
            <LogoutModalButton
              onClick={handle}
              variant="contained"
              text={t("tests.modal.do_later")}
            ></LogoutModalButton>
            <LogoutModalButton
              onClick={close}
              variant="outlined"
              text={skill ? "Finir de remplir" : t("tests.modal.finish")}
            ></LogoutModalButton>
          </CardActions>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default FinishLaterTestModal;
